import {DeleteOutlineOutlined} from '@mui/icons-material';
import {Box, Button, Typography} from '@mui/material';
import {FC} from 'react';
import {FormattedMessage} from 'react-intl';
import {useScreenTier} from 'src/hooks/useScreenTier';
import {CancelButton} from '../CancelButton';
import {SubmitButton} from '../SubmitButton';
import {
    actionsWrapperSx,
    phoneActionsSx,
    phoneCaptionSx,
    phoneConfirmSx,
    phoneDangerButtonSx,
    phoneIconSx,
    phoneKeepButtonSx,
    phoneQuestionSx,
    wrapperSx,
} from './ConformationModal.sx';
import {ConformationModalType} from './ConformationModal.types';

/**
 * The one confirmation every deletion in the product goes through.
 *
 * Below a desktop it is re-arranged rather than rewritten: the same message, the same two handlers,
 * the same permission upstream deciding whether the control that opens it exists at all.
 */
export const ConformationModal: FC<ConformationModalType> = ({
                                                                 text,
                                                                 caption,
                                                                 handleSubmit,
                                                                 handleClose,
                                                             }) => {
    const {isCompact} = useScreenTier();

    const question = caption ? (
        <FormattedMessage
            id={text}
            values={{
                name: caption,
            }}
        />
    ) : (
        <FormattedMessage id={text}/>
    );

    if (isCompact) {
        return (
            <Box sx={phoneConfirmSx}>
                <Box sx={phoneIconSx}>
                    <DeleteOutlineOutlined/>
                </Box>
                <Typography sx={phoneQuestionSx}>{question}</Typography>
                {/* The record itself, so the question is about something a reader can see. */}
                {caption && <Typography sx={phoneCaptionSx}>{caption}</Typography>}
                <Box sx={phoneActionsSx}>
                    <Button
                        variant="contained"
                        sx={phoneDangerButtonSx}
                        onClick={handleSubmit}
                    >
                        <FormattedMessage id="delete"/>
                    </Button>
                    <Button
                        variant="outlined"
                        sx={phoneKeepButtonSx}
                        onClick={handleClose}
                    >
                        <FormattedMessage id="cancel"/>
                    </Button>
                </Box>
            </Box>
        );
    }

    return (
        <Box>
            <Box sx={wrapperSx}>
                <Typography variant="subtitle1">{question}</Typography>
            </Box>
            <Box sx={actionsWrapperSx}>
                <CancelButton
                    text="cancel"
                    handler={handleClose}
                />
                <SubmitButton
                    text={'delete'}
                    handler={handleSubmit}
                />
            </Box>
        </Box>
    );
};
